import React from 'react'
import { Grid, Row, Col } from 'react-bootstrap'
import { SectionTitle } from 'Components/Section/SectionTitle'
import { Checkbox } from './../../../../../Components/Form/Checkbox'
import injectStyles from 'react-jss'
import { updateAmbassadorById } from 'Reducers/Ambassador/actions'
import { connect } from 'react-redux'

const styles = {
  withholdContainer: {
    position: 'absolute',
    top: 40,
    right: 40,
  },
  withoutCheckbox: {
    display: 'inline-block',
    verticalAlign: 'middle',
    marginRight: 20,
    marginLeft: 20,
  },
  withoutLabel: {
    display: 'inline-block',
    fontSize: 18,
    verticalAlign: 'middle',
    margin: 0,
    marginRight: 20,
    marginLeft: 20,
    fontWeight: 'normal',
  },
}

const BankDetailsSectionView = ({
  ambassadorId,
  paymentDetails,
  classes,
  updateAmbassadorById,
  withholdPay,
  fixedPriceMissions,
}) => {
  const toggleWithholdPay = () => {
    updateAmbassadorById(ambassadorId, { withhold_pay: !withholdPay })
  }
  const toggleFixedPrice = () => {
    updateAmbassadorById(ambassadorId, {
      fixedPriceMissions: !fixedPriceMissions,
    })
  }

  return (
    <Grid fluid>
      <Row>
        <Col xs={12}>
          <SectionTitle>Bank Details</SectionTitle>
        </Col>
        <div className={classes.withholdContainer}>
          <label className={classes.withoutLabel}>
            Force fixed price missions
          </label>
          <Checkbox
            className={classes.withoutCheckbox}
            input={{
              onClick: toggleFixedPrice,
              checked: fixedPriceMissions,
            }}
          />
          <span style={{ width: 50, display: 'inline-block' }} />
          <label className={classes.withoutLabel}>Withhold pay</label>
          <Checkbox
            className={classes.withoutCheckbox}
            input={{
              onClick: toggleWithholdPay,
              checked: withholdPay,
            }}
          />
        </div>
      </Row>
      {paymentDetails && (
        <Row>
          <Col xs={3}>
            <p className="col-title">Bank Name</p>
            <p>{paymentDetails.accountName || '-'}</p>
          </Col>
          <Col xs={3}>
            <p className="col-title">BSB</p>
            <p>{paymentDetails.branchNumber || '-'}</p>
          </Col>
          <Col xs={3}>
            <p className="col-title">Account Number</p>
            <p>{paymentDetails.accountNumber || '-'}</p>
          </Col>
        </Row>
      )}
    </Grid>
  )
}

const StyledBankDetailsSection = injectStyles(styles)(BankDetailsSectionView)

const ConnectedBankDetailsSection = connect(
  null,
  { updateAmbassadorById },
)(StyledBankDetailsSection)

export default ConnectedBankDetailsSection



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasador/View/BankDetailsSection.js